
Foundation.Mobile.Init = function () {
    jQuery(document).ready(this.panels.bind(this));
    jQuery(document).ready(this.missing_images.bind(this));
    this.sorts();
    this.sizer();
    this.reveals();
    this.to_top();
}

Foundation.Mobile.Init.prototype.panels = function () {
    this.panel_views = [];

    jQuery('.ui.panel').each(function (index, el) {
        this._panel_init(el)
    }.bind(this));
}

Foundation.Mobile.Init.prototype._panel_init = function (el) {
    var panel = new Foundation.Mobile.Panel(jQuery(el));
    new Foundation.LoginRequiredComponent("#panel-nav");
    this.panel_views.push(panel);

    var acc_el = jQuery(el).find('.ui.accordion');
    acc_el.accordion({
            /*
            'onBeforeOpen' : function(){
            },
            */
            'onChange': function () {
                // need to move the page
                var title = jQuery(this).prev('.title');

                title.height();
                var pos = title.position().top + title.height();
                Foundation.Mobile.Util.smoothScroll(pos);

                panel._refresh();
            }
        });
}



Foundation.Mobile.Init.prototype.sorts = function () {
    jQuery(document).on('click', '.sort-toggle', function () {
        jQuery('.sort-controls').toggle('fast', function () {
            /* noop */
        });
    });
};

Foundation.Mobile.Init.prototype.reveals = function () {
    jQuery(document).on('click', '.do-reveal', function () {
        jQuery('.do-conceal').show();
        jQuery('.do-reveal').hide();
        jQuery('.conceal').show();
    });

    jQuery(document).on('click', '.do-conceal', function () {
        jQuery('.do-conceal').hide();
        jQuery('.do-reveal').show();
        jQuery('.conceal').hide();
    });
}

Foundation.Mobile.Init.prototype.sizer = function () {
    this.sizer = new Foundation.Mobile.Sizer();
};

Foundation.Mobile.Init.prototype.to_top = function () {
    jQuery(document).on('click', '.back-to-top', function () {
        Foundation.Mobile.Util.smoothScroll(0)
    });
};

Foundation.Mobile.Init.prototype.missing_images = function () {
    jQuery("img").error(function () {
        jQuery(this).addClass('image-load-error');
    });
};


Foundation.Mobile.instance = new Foundation.Mobile.Init();

